module["exports"] = [
  "090-####-####",
  "080-####-####",
  "070-####-####"
];
